import { useEffect } from 'react'
import styled from 'styled-components'
import { useMetaStore } from '../store/MetaStore'

const Container = styled.div`
  display: grid;
  justify-content: center;
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
`

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
`

const InputGroup = styled.div`
  margin-bottom: 15px;
`

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 1.4rem;
`

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 15px;
  text-align: center;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

const PlayerLoginView = ({
  firstName, setFirstName,
  lastName, setLastName,
  email, setEmail,
  leagueName, setLeagueName,
  errorMsg, setErrorMsg,
  onSubmit, loading
}) => {
  const setPageTitle = useMetaStore((state) => state.setPageTitle)

  useEffect(() => {
    setPageTitle('Player Login')
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (firstName && lastName && email && leagueName) {
      onSubmit()
    } else {
      setErrorMsg('Please fill in all fields.')
    }
  }

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <InputGroup>
          <Label>First Name</Label>
          <Input
            type="text"
            value={firstName}
            onChange={e => { setFirstName(e.target.value); setErrorMsg('') }}
          />
        </InputGroup>
        <InputGroup>
          <Label>Last Name</Label>
          <Input
            type="text"
            value={lastName}
            onChange={e => { setLastName(e.target.value); setErrorMsg('') }}
          />
        </InputGroup>
        <InputGroup>
          <Label>Email</Label>
          <Input
            type="email"
            value={email}
            onChange={e => { setEmail(e.target.value); setErrorMsg('') }}
          />
        </InputGroup>
        <InputGroup>
          <Label>League Name</Label>
          <Input
            type="text"
            value={leagueName}
            onChange={e => { setLeagueName(e.target.value); setErrorMsg('') }}
          />
        </InputGroup>

        {errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}

        <ButtonContainer>
          <button type="submit" className="darkButton" disabled={loading} style={{ width: '100%', padding: '10px 0' }}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </ButtonContainer>
      </form>
    </Container>
  )
}

export default PlayerLoginView
